module.exports = __webpack_public_path__ + "img/CIMBT.47c58c8e.png";